var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_40_8275"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_40_8275)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,20C7.6000001,20,4,16.4,4,12C4,7.6000008999999995,7.6000001,4,12,4C16.4,4,20.000002,7.6000001,20.000002,12C20.000002,16.4,16.400002,20,12,20ZM12,18.000000999999997C15.3,18.000000999999997,18.000000999999997,15.300001,18.000000999999997,12.000001C18.000000999999997,8.700001199999999,15.3,6.000001,12,6.000001C8.7000008,6.000001,6.000000200000001,8.700001199999999,6.000000200000001,12.000001C6.000000200000001,15.300001,8.7000008,18.000000999999997,12,18.000000999999997ZM13.000001,14L13.000001,16L11.000000499999999,16L11.000000499999999,14L13.000001,14ZM13.000001,8.000000499999999L13.000001,13L11.000000499999999,13L11.000000499999999,8.000001000000001L13.000001,8.000000499999999Z",
    fill: "#E3E2E3",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleImg);
export default __webpack_public_path__ + "static/media/titleImg.e67f7d6bedb011bc0439358f54feac84.svg";
export { ForwardRef as ReactComponent };